
export default {
    "formTitle": "Add Charges",
    "tableTitle": "Charges List",
    "tableCol": [
        {
            name: 'Charge Name',
            selector: row => row.chargeName,
            sortable: true
        },
        {
            name: 'Charge Type',
            selector: row => row.chargeType,
            sortable: true
        },
        {
            name: 'Percent',
            selector: row => row.percent,
            sortable: true
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true
        },
        {
            name: 'Agency',
            selector: row => row.agency,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'select',
                    options:[
                        "Type1",
                        "Type2"
                    ],
                    label: 'Agency',
                    name: 'agency'
                }
            ]
        },
        {
            "formType": "flex",
            "formFields": [
                
                {
                    type: 'select',
                    options:[
                        "Type1",
                        "Type2"
                    ],
                    label: 'Charge Name',
                    name: 'chargeName',
                    required: true
                },
                {
                    type: 'select',
                    options:[
                        "Type1",
                        "Type2"
                    ],
                    label: 'Charge Type',
                    name: 'chargeType',
                    required: true
                },
                {
                    type: 'text',
                    label: 'Percent',
                    name: 'percent'
                    
                }
            ]
        }
        
    ],
    "mockData": [{
        "shipClass": "sfs",
        "description": "dgdg"
    }]
}